// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/scss/calendar/icon-calendar.scss
// module id = 639
// module chunks = 50